import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles, Ruler, Search as SearchIcon } from "lucide-react";

export const HeroSearchPanel = ({ profileId, profile, storeCount }) => {
    const navigate = useNavigate();
    const [q, setQ] = useState("");

    const submitSearch = (e) => {
        e.preventDefault();
        const params = new URLSearchParams();
        if (q.trim()) params.set("q", q.trim());
        navigate(`/search?${params.toString()}`);
    };

    return (
        <div className="lg:col-span-7 border-4 border-black bg-white shadow-brutal-lg p-6 md:p-10 relative overflow-hidden">
            <span className="inline-block bg-[#CCFF00] border-2 border-black px-3 py-1 font-mono text-xs uppercase tracking-widest mb-6">
                Search · Match · Order
            </span>
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter uppercase leading-[0.9]">
                ONE SEARCH.
                <br />
                EVERY STORE.
                <br />
                <span className="bg-[#FF00FF] text-white px-2">YOUR SIZE.</span>
            </h1>
            <p className="mt-6 max-w-md font-mono text-sm md:text-base leading-relaxed text-black/80">
                We scan {storeCount || "8+"} top retailers — Zara, H&amp;M, ASOS, Nike, Adidas &amp; more — and only show pieces in stock in <strong>your</strong> measurements. Order it all in one cart.
            </p>

            <form onSubmit={submitSearch} className="mt-6 flex gap-2">
                <div className="relative flex-1">
                    <SearchIcon className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-black/60" />
                    <input
                        data-testid="home-search-input"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder={'"black leather jacket", "Nike", "wide-leg jeans"…'}
                        className="w-full border-2 border-black pl-10 pr-3 py-3 font-mono text-sm focus:outline-none focus:shadow-brutal-sm"
                    />
                </div>
                <button
                    type="submit"
                    data-testid="home-search-btn"
                    className="bg-[#CCFF00] border-2 border-black px-5 py-3 font-bold uppercase tracking-widest shadow-brutal btn-press"
                >
                    Search
                </button>
            </form>

            <div className="mt-6 flex flex-wrap gap-3">
                {profileId ? (
                    <>
                        <Link
                            to="/matches"
                            data-testid="hero-matches-btn"
                            className="bg-black text-[#CCFF00] border-2 border-black px-6 py-3 font-bold uppercase tracking-widest shadow-brutal btn-press inline-flex items-center gap-2"
                        >
                            <Sparkles className="w-4 h-4" /> See My Fits
                        </Link>
                        <Link
                            to="/profile"
                            data-testid="hero-profile-btn"
                            className="bg-white border-2 border-black px-6 py-3 font-bold uppercase tracking-widest shadow-brutal btn-press inline-flex items-center gap-2"
                        >
                            <Ruler className="w-4 h-4" /> Edit Stats
                        </Link>
                    </>
                ) : (
                    <Link
                        to="/profile"
                        data-testid="hero-build-profile-btn"
                        className="bg-black text-[#CCFF00] border-2 border-black px-6 py-3 font-bold uppercase tracking-widest shadow-brutal btn-press inline-flex items-center gap-2"
                    >
                        Build my Fit Profile <ArrowRight className="w-4 h-4" />
                    </Link>
                )}
            </div>
            {profileId && profile?.name && (
                <p className="mt-5 font-mono text-xs uppercase tracking-widest text-black/60">
                    Welcome back, <span className="text-black font-bold">{profile.name.split(" ")[0]}</span>.
                </p>
            )}
        </div>
    );
};
